export default function Fail() {
	return (
		<svg width="14" height="15" viewBox="0 0 14 15" fill="none" className="toast__icon">
			<g>
				<g>
					<circle cx="7" cy="7.5" r="7" fill="white" />
				</g>
				<path d="M4.75195 9.79834L9.34815 5.20215" stroke="#404040" strokeWidth="1.5" strokeLinecap="round" />
				<path d="M4.80005 5.20215L9.39624 9.79834" stroke="#404040" strokeWidth="1.5" strokeLinecap="round" />
			</g>
		</svg>
	);
}
